import React from "react";
import { useMachine } from "@xstate/react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Game } from "./Game";
import { gameMachine } from "./stateMachine/gameStateMachine";

const App = () => {
  const [state, send] = useMachine(gameMachine);

  send("FETCH");

  console.log(state.value.toString());
  console.log(state.context);

  return (
    <DndProvider backend={HTML5Backend}>
      <div>
        <h1 className="center">Card Catalog</h1>
        <p className="center">
          The books below were on one of The New York Time's{" "}
          {state.context.pickedDate} best-sellers lists.
        </p>
        <p className="center">
          They have been sorted into distinct categories (and named) by an AI.
        </p>
        <p className="center">
          Over two rounds, drag the books to the category that matches them
          best. (You may also double click to get a description of the book.)
        </p>
        <p className="center">
          Correct answers are worth 1 point in the first round, and 2 in the
          second.
        </p>
        <p>Current state: {state.value.toString()}</p>
        <p>Score: {state.context.score}</p>
        <Game state={state} send={send} />
      </div>
    </DndProvider>
  );
};

export default App;
